import React, { Component } from 'react';
import './App.css';
import AppRouter from './config/AppRouter';

class App extends Component {
    render() {
    	return(
    		<AppRouter />
    	);
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js